import * as React from 'react';
import { useSelector } from 'react-redux';
import { useRenderers } from '../../../../../../renderProps';
import { getIsExchangeAutoMode, getOrderId } from '../../../../../../Checkout/store/order/selectors';
import Flight from '../../../../../../Flight/Flight';
import { getSelectedFlightsCount } from '@entities/exchange';
import { useSelectFlight } from '../../model/useSelectFlight';
const SelectFlight = ({ flight }) => {
    const orderId = useSelector(getOrderId);
    const selectedFlightsCount = useSelector(getSelectedFlightsCount);
    const isAutoMode = useSelector(getIsExchangeAutoMode);
    const isHidePrice = !isAutoMode;
    const isEmptyPrices = flight.pricesForFareGroups.every(priceGroup => !priceGroup.prices || priceGroup.prices.every(price => !price.price));
    const { onSelectExchangeFlight } = useSelectFlight();
    const { ExchangeFlight = Flight } = useRenderers();
    return (React.createElement(ExchangeFlight, { orderId: orderId, flight: flight, hidePrice: isHidePrice, hideOnlyPrice: isEmptyPrices, isReturnFlight: selectedFlightsCount === 1, isPreOpen: false, isPreOpenAvailable: false, onSelect: onSelectExchangeFlight }));
};
export default SelectFlight;
